import { SUBJECT_NAME_MAX_LENGTH } from '@app/constant/form-validation.constants';
import { getNameValidationError } from '@app/utils/name-validation';

export const SUBJECT_NAME_INVALID_CHARACTERS = /[~`@$%^_+=}\]>{\[</:;"'\\|]+/;

export function getSubjectNameError(
  value: string | null | undefined,
  maxLength: number = SUBJECT_NAME_MAX_LENGTH
): string | null {
  return getNameValidationError(value, maxLength, SUBJECT_NAME_INVALID_CHARACTERS, {
    invalidChar: 'STUDENT_NAME_INVALID_CHAR_ERROR',
    invalidLength: 'STUDENT_NAME_INVALID_LENGTH_ERROR'
  });
}
